__webpack_require__.p = "/wp-content/plugins/confstack-agenda/app/build/";